module.exports = __webpack_public_path__ + "static/img/image_logo@3x(5).bd4a2ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/image_logo@3x(5).png
// module id = 245
// module chunks = 18